export const translations = {
    en: {
        // Navigation
        nav: {
            home: 'Home',
            about: 'About',
            team: 'Our Team',
            practice: 'Practice',
            blogs: 'Blogs',
            contact: 'Contact'
        },

        // Header
        header: {
            locations: 'Delhi | Noida | Allahabad | Gorakhpur',
            freeConsultation: 'Free Consultation',
            haveQuestions: 'Have questions? Call us now:'
        },

        // Hero Section
        hero: {
            slide1Title: 'Your Trusted Legal Partners in Every Matter',
            slide1Subtitle: 'Offering clear and effective strategies for your unique challenges',
            slide1Button: 'Explore Our Services',
            slide2Title: 'Fighting for Justice, Protecting Your Rights',
            slide2Subtitle: 'Connect confidently with Legal Corridor, where expert assistance awaits for your legal needs.',
            slide2Button: 'Schedule Consultation',
            slide3Title: 'Expert Legal Advice, Exceptional Results',
            slide3Subtitle: 'Free Initial Consultation Available',
            slide3Button: 'Get Free Advice'
        },

        // Statistics
        stats: {
            casesWon: 'Associates',
            happyClients: 'Happy Clients',
            yearsExperience: 'Years Experience',
            officeLocations: 'Office Locations'
        },

        // About Section
        about: {
            title: 'Welcome to Legal Corridor',
            subtitle: 'About Our Firm',
            readMore: 'Read More'
        },

        // Why Choose Us
        whyChooseUs: {
            title: 'Why Choose Us',
            subtitle: 'Your Trusted Legal Partners',
            expertCounsel: 'Expert Legal Counsel',
            expertCounselDesc: 'Our seasoned attorneys bring decades of combined experience across diverse practice areas.',
            clientCentric: 'Client-Centric Approach',
            clientCentricDesc: 'We prioritize your needs, offering personalized strategies tailored to your unique situation.',
            provenTrack: 'Proven Track Record',
            provenTrackDesc: 'Hundreds of successful cases and satisfied clients across Supreme Court and High Courts.',
            transparent: 'Transparent Communication',
            transparentDesc: 'Clear, honest updates throughout your case with no hidden fees or surprises.',
            availability: '24/7 Availability',
            availabilityDesc: 'Round-the-clock support for urgent legal matters. We are always here when you need us.',
            confidentiality: 'Confidentiality Assured',
            confidentialityDesc: 'Your information is protected with the highest standards of attorney-client privilege.'
        },

        // Services
        services: {
            title: 'Our Practice Areas',
            subtitle: 'Comprehensive Legal Services',
            divorceTitle: 'Divorce Law & Family Matters',
            divorceDesc: 'Expert handling of marriage, child custody, maintenance, domestic violence, and divorce cases. We secure favorable judgments with compassion and efficiency.',
            recoveryTitle: 'Recovery & Cheque Bounce',
            recoveryDesc: 'Comprehensive advice on banking law, secured lending, and loan finance. Expert drafting of loan documentation and negotiable instruments recovery.',
            corporateTitle: 'Corporate & Commercial Litigation',
            corporateDesc: 'Representing clients in local and international litigation. Strategic dispute resolution for high-stakes commercial matters with global impact.',
            criminalTitle: 'Criminal Law Defense',
            criminalDesc: 'Renowned specialists tackling complex criminal cases. Expert guidance across all facets of criminal defense to secure the most favorable outcomes.',
            contractTitle: 'Contract Drafting & Review',
            contractDesc: 'Comprehensive corporate legal services tailored for businesses and startups. Expert contract drafting that protects your interests.',
            propertyTitle: 'Property & Real Estate Law',
            propertyDesc: 'Premier legal advice for property transactions, RERA matters, and real estate disputes. Protecting your investments at every stage.'
        },

        // Testimonials
        testimonials: {
            title: 'Client Testimonials',
            subtitle: 'What Our Clients Say'
        },

        // Contact Section
        contact: {
            title: "We're Here To Help",
            subtitle: 'Get In Touch',
            description: "Have a legal question? Reach out to us and we'll get back to you within 24 hours.",
            officeAddress: 'Office Address',
            phoneNumber: 'Phone Number',
            emailAddress: 'Email Address',
            workingHours: 'Working Hours',
            workingHoursValue: 'Mon - Sat: 10:00 AM - 7:00 PM',
            emergency: 'Emergency: 24/7 Available',
            scheduleConsultation: 'Schedule a Consultation',
            requestCallback: 'Request a Callback',
            formDescription: 'Fill out the form below and our team will get back to you within 24 hours.',
            fullName: 'Enter Your Full Name',
            mobileNumber: 'Enter Your Mobile Number',
            email: 'Enter Your Email',
            city: 'Enter Your City',
            legalIssue: 'Enter Your Legal Issue',
            contactNow: 'Contact Now',
            chatWhatsApp: 'Chat on WhatsApp'
        },

        // Blog Section
        blog: {
            title: 'Latest News',
            subtitle: 'Legal Insights & Updates',
            readMore: 'Read More'
        },

        // CTA Section
        cta: {
            title: 'Ready to Discuss Your Legal Matters?',
            description: 'Get expert legal advice with a free initial consultation. Our experienced attorneys are ready to help you navigate any legal challenge.',
            callNow: 'Call Now',
            freeConsultation: 'Free Consultation'
        },

        // Footer
        footer: {
            quickLinks: 'Quick Link',
            practiceAreas: 'Practice Area',
            contactUs: 'Contact Us',
            headOffice: 'Head Office Address',
            allRightsReserved: 'All Rights Reserved',
            returnPolicy: 'Return and Refund Policy',
            termsConditions: 'Terms and Conditions'
        },

        // Common
        common: {
            learnMore: 'Learn More',
            submit: 'Submit',
            loading: 'Loading...',
            success: 'Success',
            error: 'Error'
        }
    },

    hi: {
        // Navigation
        nav: {
            home: 'होम',
            about: 'हमारे बारे में',
            team: 'हमारी टीम',
            practice: 'प्रैक्टिस',
            blogs: 'ब्लॉग',
            contact: 'संपर्क करें'
        },

        // Header
        header: {
            locations: 'दिल्ली | नोएडा | इलाहाबाद | गोरखपुर',
            freeConsultation: 'निःशुल्क परामर्श',
            haveQuestions: 'कोई प्रश्न हैं? अभी कॉल करें:'
        },

        // Hero Section
        hero: {
            slide1Title: 'हर मामले में आपके विश्वसनीय कानूनी साझेदार',
            slide1Subtitle: 'आपकी अनूठी चुनौतियों के लिए स्पष्ट और प्रभावी रणनीतियां पेश करते हैं',
            slide1Button: 'हमारी सेवाएं देखें',
            slide2Title: 'न्याय के लिए लड़ना, आपके अधिकारों की रक्षा करना',
            slide2Subtitle: 'लीगल कॉरिडोर से आत्मविश्वास के साथ जुड़ें, जहां आपकी कानूनी जरूरतों के लिए विशेषज्ञ सहायता उपलब्ध है।',
            slide2Button: 'परामर्श का समय निर्धारित करें',
            slide3Title: 'विशेषज्ञ कानूनी सलाह, असाधारण परिणाम',
            slide3Subtitle: 'निःशुल्क प्रारंभिक परामर्श उपलब्ध',
            slide3Button: 'निःशुल्क सलाह लें'
        },

        // Statistics
        stats: {
            casesWon: 'एसोसिएट्स',
            happyClients: 'खुश ग्राहक',
            yearsExperience: 'वर्षों का अनुभव',
            officeLocations: 'कार्यालय स्थान'
        },

        // About Section
        about: {
            title: 'लीगल कॉरिडोर में आपका स्वागत है',
            subtitle: 'हमारी फर्म के बारे में',
            readMore: 'और पढ़ें'
        },

        // Why Choose Us
        whyChooseUs: {
            title: 'हमें क्यों चुनें',
            subtitle: 'आपके विश्वसनीय कानूनी साझेदार',
            expertCounsel: 'विशेषज्ञ कानूनी सलाह',
            expertCounselDesc: 'हमारे अनुभवी वकील विभिन्न प्रैक्टिस क्षेत्रों में दशकों का संयुक्त अनुभव लाते हैं।',
            clientCentric: 'ग्राहक-केंद्रित दृष्टिकोण',
            clientCentricDesc: 'हम आपकी जरूरतों को प्राथमिकता देते हैं, आपकी अनूठी स्थिति के अनुरूप व्यक्तिगत रणनीतियां पेश करते हैं।',
            provenTrack: 'सिद्ध ट्रैक रिकॉर्ड',
            provenTrackDesc: 'सुप्रीम कोर्ट और हाई कोर्ट में सैकड़ों सफल मामले और संतुष्ट ग्राहक।',
            transparent: 'पारदर्शी संचार',
            transparentDesc: 'बिना किसी छिपी फीस या आश्चर्य के आपके मामले में स्पष्ट, ईमानदार अपडेट।',
            availability: '24/7 उपलब्धता',
            availabilityDesc: 'तत्काल कानूनी मामलों के लिए चौबीसों घंटे सहायता। हम हमेशा आपके साथ हैं।',
            confidentiality: 'गोपनीयता सुनिश्चित',
            confidentialityDesc: 'वकील-ग्राहक विशेषाधिकार के उच्चतम मानकों के साथ आपकी जानकारी सुरक्षित है।'
        },

        // Services
        services: {
            title: 'हमारे प्रैक्टिस क्षेत्र',
            subtitle: 'व्यापक कानूनी सेवाएं',
            divorceTitle: 'तलाक कानून और पारिवारिक मामले',
            divorceDesc: 'विवाह, बाल हिरासत, भरण-पोषण, घरेलू हिंसा और तलाक के मामलों का विशेषज्ञ प्रबंधन। हम करुणा और दक्षता के साथ अनुकूल निर्णय प्राप्त करते हैं।',
            recoveryTitle: 'वसूली और चेक बाउंस',
            recoveryDesc: 'बैंकिंग कानून, सुरक्षित उधार और ऋण वित्त पर व्यापक सलाह। ऋण दस्तावेज़ीकरण और परक्राम्य लिखतों की वसूली का विशेषज्ञ प्रारूपण।',
            corporateTitle: 'कॉर्पोरेट और वाणिज्यिक मुकदमेबाजी',
            corporateDesc: 'स्थानीय और अंतर्राष्ट्रीय मुकदमेबाजी में ग्राहकों का प्रतिनिधित्व। वैश्विक प्रभाव वाले उच्च-दांव वाणिज्यिक मामलों के लिए रणनीतिक विवाद समाधान।',
            criminalTitle: 'आपराधिक कानून बचाव',
            criminalDesc: 'जटिल आपराधिक मामलों से निपटने वाले प्रसिद्ध विशेषज्ञ। सबसे अनुकूल परिणाम प्राप्त करने के लिए आपराधिक बचाव के सभी पहलुओं में विशेषज्ञ मार्गदर्शन।',
            contractTitle: 'अनुबंध प्रारूपण और समीक्षा',
            contractDesc: 'व्यवसायों और स्टार्टअप के लिए व्यापक कॉर्पोरेट कानूनी सेवाएं। विशेषज्ञ अनुबंध प्रारूपण जो आपके हितों की रक्षा करता है।',
            propertyTitle: 'संपत्ति और रियल एस्टेट कानून',
            propertyDesc: 'संपत्ति लेनदेन, रेरा मामलों और रियल एस्टेट विवादों के लिए प्रमुख कानूनी सलाह। हर चरण में आपके निवेश की सुरक्षा।'
        },

        // Testimonials
        testimonials: {
            title: 'ग्राहक प्रशंसापत्र',
            subtitle: 'हमारे ग्राहक क्या कहते हैं'
        },

        // Contact Section
        contact: {
            title: 'हम यहां मदद के लिए हैं',
            subtitle: 'संपर्क करें',
            description: 'कोई कानूनी प्रश्न है? हमसे संपर्क करें और हम 24 घंटे के भीतर आपसे संपर्क करेंगे।',
            officeAddress: 'कार्यालय का पता',
            phoneNumber: 'फोन नंबर',
            emailAddress: 'ईमेल पता',
            workingHours: 'कार्य के घंटे',
            workingHoursValue: 'सोम - शनि: सुबह 10:00 - शाम 7:00',
            emergency: 'आपातकालीन: 24/7 उपलब्ध',
            scheduleConsultation: 'परामर्श का समय निर्धारित करें',
            requestCallback: 'कॉलबैक का अनुरोध करें',
            formDescription: 'नीचे दिया गया फॉर्म भरें और हमारी टीम 24 घंटे के भीतर आपसे संपर्क करेगी।',
            fullName: 'अपना पूरा नाम दर्ज करें',
            mobileNumber: 'अपना मोबाइल नंबर दर्ज करें',
            email: 'अपना ईमेल दर्ज करें',
            city: 'अपना शहर दर्ज करें',
            legalIssue: 'अपना कानूनी मुद्दा दर्ज करें',
            contactNow: 'अभी संपर्क करें',
            chatWhatsApp: 'व्हाट्सएप पर चैट करें'
        },

        // Blog Section
        blog: {
            title: 'ताज़ा खबरें',
            subtitle: 'कानूनी अंतर्दृष्टि और अपडेट',
            readMore: 'और पढ़ें'
        },

        // CTA Section
        cta: {
            title: 'अपने कानूनी मामलों पर चर्चा करने के लिए तैयार हैं?',
            description: 'निःशुल्क प्रारंभिक परामर्श के साथ विशेषज्ञ कानूनी सलाह प्राप्त करें। हमारे अनुभवी वकील किसी भी कानूनी चुनौती में आपकी मदद करने के लिए तैयार हैं।',
            callNow: 'अभी कॉल करें',
            freeConsultation: 'निःशुल्क परामर्श'
        },

        // Footer
        footer: {
            quickLinks: 'त्वरित लिंक',
            practiceAreas: 'प्रैक्टिस क्षेत्र',
            contactUs: 'संपर्क करें',
            headOffice: 'मुख्य कार्यालय का पता',
            allRightsReserved: 'सर्वाधिकार सुरक्षित',
            returnPolicy: 'वापसी और धनवापसी नीति',
            termsConditions: 'नियम और शर्तें'
        },

        // Common
        common: {
            learnMore: 'और जानें',
            submit: 'जमा करें',
            loading: 'लोड हो रहा है...',
            success: 'सफल',
            error: 'त्रुटि'
        }
    }
};
